module.exports = __webpack_public_path__ + "static/img/2-30w.e86ca8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/two/2-30w.png
// module id = ntXl
// module chunks = 1